import type { AuthService } from './auth.service';

export function authAppInitializerFactory(authService: AuthService): () => Promise<unknown> {
  return () => authService.runInitialLoginSequence();
}
